<div [formGroup]="form">

    <kal-form-field>

        <kal-select [label]="controlLabel"
                    formControlName="operator"
                    placeholder="Sélectionner un comparateur">

            <kal-option *ngFor="let operator of operatorOptionsList"
                        [value]="operator.id" title="{{ operator.label }}">
                {{ operator.id }}
            </kal-option>

        </kal-select>

        <span (click)="setBetweenOperator()" *ngIf="!isBetweenOperator" class="gup-O-link -secondary">Définir une période</span>

    </kal-form-field>

    <kal-form-field class="without-label">

        <kal-datepicker [errorsMessage]="errorsMessages"
                        [placeholder]="placeholder(startPlaceholder)"
                        formControlName="startDate">
        </kal-datepicker>

    </kal-form-field>

    <div *ngIf="dateEndControl.enabled">

        <span> {{betweenLabel}} </span>

        <kal-form-field class="without-label">

            <kal-datepicker [errorsMessage]="errorsMessages"
                            [placeholder]="endPlaceholder"
                            formControlName="endDate">
            </kal-datepicker>

        </kal-form-field>

    </div>

    <p *ngIf="form.hasError('invaliddaterange')"
       class="gup-O-msg -error">
        {{errorsMessages['invaliddaterange']}}
    </p>

</div>
